// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"713f79e5","456":"b9ea0a8b","656":"48b2cb57","756":"5347502e","787":"2750af70","968":"a2df270b"}[chunkId] + ".chunk.js";
};